import React from "react";
import { CALENDAR_ICON } from "../utils/svgs_new";
import { AppIcon } from "./Generic/AppIcon";
import Checkbox from "./Generic/Checkbox";

interface Props {
  isChecked: boolean | null;
  onClick: () => void;
}

function AvailableFlexibleShiftLeading(props: Props) {
  if (props.isChecked === null) {
    return <AppIcon icon={CALENDAR_ICON} fill="primary" />;
  }

  return <Checkbox onClick={props.onClick} checked={props.isChecked} />;
}

export default AvailableFlexibleShiftLeading;
